<template>
  <v-app style="background: #eee">
    <nav class="ma-3">
      <v-layout justify-center>
        <v-flex xs12 sm6>
          <v-card flat color="#eee">
            <v-form>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pa-1">
                  <v-autocomplete
                    v-model="source"
                    :items="locations"
                    label="Source"
                    persistent-hint
                    color="black"
                  >
                    <template v-slot:append-outer>
                      <v-slide-x-reverse-transition mode="out-in"></v-slide-x-reverse-transition>
                    </template>
                  </v-autocomplete>
                </v-flex>
                
                <v-flex xs12 sm6 class="pa-1">
                  <v-autocomplete
                    v-model="destination"
                    :items="locations"
                    label="Destination"
                    persistent-hint
                    color="black"
                  >
                    <template v-slot:append-outer>
                      <v-slide-x-reverse-transition mode="out-in"></v-slide-x-reverse-transition>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <v-flex xs12 sm6 class="pa-1">
                  <v-menu
                    v-model="datemenu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="200px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label="Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        color="black"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" @input="datemenu2 = false" color="#35455c"></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm6 class="pa-1">
                  <v-menu
                    ref="menu"
                    v-model="timemenu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                    color="black"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="time"
                        label="Time"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                        color="black"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="timemenu2"
                      v-model="time"
                      full-width
                      @click:minute="$refs.menu.save(time)"
                      color="#35455c"
                    ></v-time-picker>
                  </v-menu>
                </v-flex>
                <v-layout justify-center>
                  <v-btn large round @click="submitQuery" color="#35455c" dark>Search</v-btn>
                </v-layout>
              </v-layout>
            </v-form>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-divider />
      <br />
      <v-layout row wrap>
        <v-flex v-for="doc in docs" v-if="checkOwnId(doc.data().posted_by.uid)" xs12 sm6 md4>
          <div class="mr-5 ml-5">
            <Searchcard
              :source="doc.data().source"
              :destination="doc.data().destination"
              :posted_by="doc.data().posted_by"
              :cab_booked="doc.data().cab_booked"
              :date="doc.data().date_time.toDate().toLocaleDateString()"
              :time="doc.data().date_time.toDate().toLocaleTimeString().substr(0,5)"
              :accept_limit="doc.data().accept_limit"
              :accepted_count="doc.data().accepted.length"
              :postId="doc.id"
              :alreadyRequested="checkAlreadyRequested(doc)"
              :alreadyAccepted="checkAlreadyAccepted(doc)"
              :alreadyRejected="checkAlreadyRejected(doc)"
            ></Searchcard>
          </div>
        </v-flex>
      </v-layout>
    </nav>
  </v-app>
</template>

<script>
import Searchcard from "@/components/Searchcard.vue";
import firebase from "firebase";

export default {
  components: {
    Searchcard
  },

  data() {
    return {
      listener : null,
      docs : [],
      source : '',
      destination : '',
      date : '',
      time : '',
      locations: [
        'Campus, IIT Kanpur',
        'Kanpur Central Railway Station (CNB)',
        'Govindpuri Railway Station',
        'Kalyanpur Railway Station',
        'Kanpur Anwarganj Railway Station',
        'Jhakarkati Bus Stand',
        'Fazalganj Bus Depot (Samayshatabdi Terminal)',
        'Azad Nagar Bus Station',
        'Kanpur Airport (Chakeri)',
        'Lucknow Airport (Amausi)',
        'Z Square Mall',
        'Rave 3 Mall',
        'Rave Moti Mall',
        'South X Mall',
      ],
      //Temporary Data:
      menu: false,
      modal: false,
      datemenu2: false,
      timemenu2: false,
      modal2: false
    };
  },

  methods: {
    datetime() {
      return new Date(this.date + "T" + this.time + ":00+05:30");
    },
    
    submitQuery(){
      var vm=this;
      let before45 = this.datetime()
      let after45 = this.datetime()
      before45.setMinutes(before45.getMinutes()-45);
      after45.setMinutes(after45.getMinutes()+45);
      const db = firebase.firestore()
      vm.listener();
      db.collection("posts")
      .where('source', '==', this.source)
      .where('destination', '==', this.destination)
      .where('post_closed', '==', false)
      .where('date_time', '>=', firebase.firestore.Timestamp.fromDate(before45))
      .where('date_time', '<=', firebase.firestore.Timestamp.fromDate(after45))
      .orderBy('date_time')
      .onSnapshot(function (querySnapshot) {
        console.log("Query Listener Activated");
        vm.docs=querySnapshot.docs;
      })
    },

    checkOwnId: function(id) {
      return id != firebase.auth().currentUser.uid;
    },

    checkAlreadyRequested(doc){
      var AlreadyRequested = false;
      var currentId = firebase.auth().currentUser.uid
      for (var user of doc.data().requests){
        if (user.uid == currentId){
          AlreadyRequested = true;
        }
      }
      return AlreadyRequested;
    },
    checkAlreadyAccepted(doc){
      const db = firebase.firestore();
      var AlreadyAccepted = false;
      var currentId = firebase.auth().currentUser.uid
      for (var user of doc.data().accepted){
        if (user.uid == currentId){
          AlreadyAccepted = true;
        }
      };
      return AlreadyAccepted;
    },
    checkAlreadyRejected(doc){
      const db = firebase.firestore();
      var AlreadyRejected = false;
      var currentId = firebase.auth().currentUser.uid
      for (var user of doc.data().rejected){
        if (user == currentId){
          AlreadyRejected = true;
        }
      };
      return AlreadyRejected;
    }
  },

  mounted() {
    const db = firebase.firestore();
    var vm=this;
    vm.listener = db.collection("posts").where("post_closed","==",false)
      .onSnapshot(function (querySnapshot) {
        vm.docs=querySnapshot.docs;
      })
  },
  beforeDestroy(){
    var vm=this;
    vm.listener();
  },

  computed: {}
};
</script>